import React, { useState, useEffect } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect, useParams, Link } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/certificate.css";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";
import MdlSelectMultipleStudent from "../dialog/MdlSelectMultipleStudent";
import MdlSelectMultipleStaff from "../dialog/MdlSelectMultipleStaff";
import BackButton from "../ChildComponent/BackButton";

const AppreciationCertificate = () => {
  const { document_type } = useParams();

  const [loggedIn] = useState(!!localStorage.getItem("token"));
  const [Loading, setLoading] = useState(false);
  const [isOpenSelectStudent, setIsOpenSelectStudent] = useState(false);
  const [isOpenSelectStaff, setIsOpenSelectStaff] = useState(false);
  const [showStudentIdCard, setShowStudentIdCard] = useState(false);
  const [mSelectedStudent, setMSelectedStudent] = useState([]);
  const [mSelectedStaff, setMSelectedStaff] = useState([]);
  const [mPrintableSamples, setMPrintableSamples] = useState([]);
  const [mColorOption, setMColorOption] = useState([]);
  const [FILE_URL, setFILE_URL] = useState("");
  const [FILE_NAME, setFILE_NAME] = useState("");
  const [FILE_DIRECTORY, setFILE_DIRECTORY] = useState("");
  const [DOCUMENT_TYPE] = useState(document_type);
  const [SELECTED_SAMPLE_ID, setSELECTED_SAMPLE_ID] = useState("");
  const [SELECTED_SAMPLE_POSITION, setSELECTED_SAMPLE_POSITION] = useState(0);
  const [SELECTED_COLOR_POSITION, setSELECTED_COLOR_POSITION] = useState(0);
  const [COLOR_OPTION_ID, setCOLOR_OPTION_ID] = useState("");
  const [SELECTION_TYPE, setSELECTION_TYPE] = useState("");
  const [height, setHeight] = useState("300px");

  const CERTIFICATE_TYPES_FALLBACK = [
    {
      value: "STUDENT_APPRECIATION",
      label: "Student Appreciation",
      title: "STUDENT APPRECIATION CERTIFICATE",
      subtitle: "STUDENT APPRECIATION",
      body:
        "is hereby appreciated for sincere effort, dedication and outstanding achievements.",
      title_font_size: "2.5rem",
      subtitle_font_size: "1.25rem",
      body_font_size: "1.125rem",
      name_font_size: "2.5rem",
      school_name_font_size: "1.75rem",
      icon: "fa-user-graduate",
      color: "#a855f7",
      selection_scope: "student",
    },
    {
      value: "STUDENT_OF_YEAR",
      label: "Student of the Year",
      title: "STUDENT OF THE YEAR",
      subtitle: "STUDENT OF THE YEAR",
      body:
        "is awarded Student of the Year for outstanding academic performance, discipline, and overall excellence.",
      title_font_size: "2.5rem",
      subtitle_font_size: "1.25rem",
      body_font_size: "1.125rem",
      name_font_size: "2.5rem",
      school_name_font_size: "1.75rem",
      icon: "fa-star",
      color: "#f59e0b",
      selection_scope: "student",
    },
    {
      value: "SMART_STUDY",
      label: "SmartStudy",
      title: "SMART STUDY CERTIFICATE",
      subtitle: "SMART STUDY GROUP APPRECIATION",
      body:
        "has regularly shared homework and study updates in the Smart Study Group with dedication and discipline. Your hard work is truly appreciated. Keep Learning, Keep Growing!",
      title_font_size: "2.5rem",
      subtitle_font_size: "1.25rem",
      body_font_size: "1.125rem",
      name_font_size: "2.5rem",
      school_name_font_size: "1.75rem",
      icon: "fa-book",
      color: "#0ea5e9",
      selection_scope: "student",
    },
    {
      value: "BEST_TEACHER",
      label: "Best Teacher Certificate",
      title: "BEST TEACHER CERTIFICATE",
      subtitle: "BEST TEACHER AWARD",
      body:
        "is hereby awarded the Best Teacher Certificate in recognition of outstanding teaching excellence, dedication to students, and exemplary contribution to the institution.",
      title_font_size: "2.7rem",
      subtitle_font_size: "1.25rem",
      body_font_size: "1.25rem",
      name_font_size: "2.5rem",
      school_name_font_size: "1.75rem",
      icon: "fa-chalkboard-teacher",
      color: "#10b981",
      selection_scope: "staff",
    },
    {
      value: "STAFF_APPRECIATION",
      label: "Staff Appreciation",
      title: "STAFF APPRECIATION CERTIFICATE",
      subtitle: "STAFF APPRECIATION",
      body:
        "is hereby recognised and appreciated for sincere dedication, steadfast commitment, and invaluable service rendered to the institution.",
      title_font_size: "2.5rem",
      subtitle_font_size: "1.25rem",
      body_font_size: "1.25rem",
      name_font_size: "2.5rem",
      school_name_font_size: "1.75rem",
      icon: "fa-users",
      color: "#3b82f6",
      selection_scope: "staff",
    },
  ];

  const [certificateTypes, setCertificateTypes] = useState(
    CERTIFICATE_TYPES_FALLBACK
  );
  const [certificateType, setCertificateType] = useState("STUDENT_APPRECIATION");
  const STAFF_DOCUMENT_TYPE = "appreciation_certificate_staff";

  useEffect(() => {
    getCertificateTypes();
    getPrintableSamples(DOCUMENT_TYPE, "student");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Created By Cursor
  const getCertificateTypes = () => {
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    if (!SCHOOL_CODE) return;

    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      "getCertificateTypes.php";

    axios
      .get(URL, { params: { school_code: SCHOOL_CODE } })
      .then((res) => res.data)
      .then((response) => {
        if (response.api_status === "OK" && Array.isArray(response.data)) {
          const mapped = response.data.map((row) => ({
            value: row.certificate_type,
            label: row.label,
            title: row.title,
            subtitle: row.subtitle || "",
            body: row.body || "",
            title_font_size: row.title_font_size || "2.5rem",
            subtitle_font_size: row.subtitle_font_size || "1.25rem",
            body_font_size: row.body_font_size || "1.125rem",
            name_font_size: row.name_font_size || "2.5rem",
            school_name_font_size: row.school_name_font_size || "1.75rem",
            icon: row.icon || "fa-certificate",
            color: row.color || "#3b82f6",
            selection_scope: row.selection_scope || "student",
          }));
          if (mapped.length > 0) {
            setCertificateTypes(mapped);
          }
        }
      })
      .catch((error) => {
        console.log("certificate types fallback", error);
      });
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.iframeHeight) {
        setHeight(`${event.data.iframeHeight}px`);
      }
    };
    window.addEventListener("message", handleMessage, false);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  //Created By Cursor
  const getPrintableSamples = (
    docType = DOCUMENT_TYPE,
    selectionType = SELECTION_TYPE,
    certType = certificateType,
    selectedPeople = null
  ) => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getPrintableSample.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          document_type: docType,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          const samples = Array.isArray(response.data) ? response.data : [];
          setMPrintableSamples(samples);
          setSELECTED_SAMPLE_POSITION(0);
          setSELECTED_COLOR_POSITION(0);
          setSample(0, samples, selectionType, certType, selectedPeople);
        } else {
          setMPrintableSamples([]);
          setFILE_NAME("");
          setFILE_DIRECTORY("");
          setSELECTED_SAMPLE_ID("");
          setMColorOption([]);
          setFILE_URL("");
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("error>>>>>", error);
      });
  };

  const isStaffCertificateType = (type = certificateType) =>
    type === "STAFF_APPRECIATION" || type === "BEST_TEACHER";

  //Created By Cursor
  const getTemplateDisplayName = (item, index) => {
    const certMeta =
      certificateTypes.find((t) => t.value === certificateType) ||
      certificateTypes[0];
    const typeLabel = certMeta.label || "Certificate";
    const nameMatch = String(item.sample_name || "").match(/(\d+)/);
    const sampleNo = nameMatch ? nameMatch[1] : String(index + 1);
    return `${typeLabel} ${sampleNo}`;
  };

  //Created By Cursor
  const setSample = (
    selected_sample_position,
    samples = mPrintableSamples,
    selectionType = SELECTION_TYPE,
    certType = certificateType,
    selectedPeople = null
  ) => {
    if (!samples || samples.length === 0 || selected_sample_position >= samples.length) {
      setFILE_NAME("");
      setFILE_DIRECTORY("");
      setSELECTED_SAMPLE_ID("");
      setMColorOption([]);
      return;
    }

    const sample = samples[selected_sample_position];
    const fileName = sample.file_name || "";
    const fileDirectory = sample.file_directory || "";
    const sampleId = sample.sample_id || "";
    const colorOptions = sample.color_options || [];

    setFILE_NAME(fileName);
    setFILE_DIRECTORY(fileDirectory);
    setSELECTED_SAMPLE_ID(sampleId);
    setMColorOption(colorOptions);

    const colorIndex =
      colorOptions[SELECTED_COLOR_POSITION] != null &&
      colorOptions[SELECTED_COLOR_POSITION]
        ? SELECTED_COLOR_POSITION
        : 0;
    setSELECTED_COLOR_POSITION(colorIndex);

    const selectedColor = colorOptions[colorIndex];
    const colorOptionId = selectedColor ? selectedColor.color_option_id : "";
    setCOLOR_OPTION_ID(colorOptionId);

    const selection =
      selectedPeople != null
        ? selectedPeople
        : selectionType === "staff"
        ? mSelectedStaff
        : mSelectedStudent;
    if (selection.length > 0) {
      setFileUrL(
        selection,
        fileName,
        fileDirectory,
        sampleId,
        colorOptionId,
        certType,
        selectionType
      );
    }
  };

  //Created By Cursor
  const setFileUrL = (
    studentsOrStaff = SELECTION_TYPE === "staff" ? mSelectedStaff : mSelectedStudent,
    fileName = FILE_NAME,
    fileDirectory = FILE_DIRECTORY,
    sampleId = SELECTED_SAMPLE_ID,
    colorOptionId = COLOR_OPTION_ID,
    certType = certificateType,
    selectionType = SELECTION_TYPE
  ) => {
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const currentSession = SessionManager.getCurrentSession();
    let session_id = (currentSession && currentSession.session_id) || "";

    const mIds = (studentsOrStaff || []).map((item) => {
      if (item.session_id) {
        session_id = item.session_id;
      }
      return item.student_enrollment_no || item.staff_id;
    });

    if (!mIds.length || !fileName || !fileDirectory) {
      setFILE_URL("");
      return;
    }

    const certMeta =
      certificateTypes.find((t) => t.value === certType) || certificateTypes[0];
    const certTitle = certMeta.title;
    const certSubtitle = certMeta.subtitle || "";
    const certBody = certMeta.body || "";
    const titleFontSize = certMeta.title_font_size || "";
    const subtitleFontSize = certMeta.subtitle_font_size || "";
    const bodyFontSize = certMeta.body_font_size || "";
    const nameFontSize = certMeta.name_font_size || "";
    const schoolNameFontSize = certMeta.school_name_font_size || "";

    const url =
      process.env.REACT_APP_SERVER_NAME +
      fileDirectory +
      fileName +
      "?&student_ids=" +
      encodeURIComponent(JSON.stringify(mIds)) +
      "&class_id=" +
      "" +
      "&section_id=" +
      "" +
      "&session_id=" +
      session_id +
      "&sample_id=" +
      sampleId +
      "&selection_type=" +
      selectionType +
      "&certificate_type=" +
      encodeURIComponent(certType) +
      "&system_code=" +
      process.env.REACT_APP_SYSTEM_CODE +
      "&color_option_id=" +
      colorOptionId +
      "&certificate_title=" +
      encodeURIComponent(certTitle) +
      "&certificate_subtitle=" +
      encodeURIComponent(certSubtitle) +
      "&certificate_body=" +
      encodeURIComponent(certBody) +
      "&title_font_size=" +
      encodeURIComponent(titleFontSize) +
      "&subtitle_font_size=" +
      encodeURIComponent(subtitleFontSize) +
      "&body_font_size=" +
      encodeURIComponent(bodyFontSize) +
      "&name_font_size=" +
      encodeURIComponent(nameFontSize) +
      "&school_name_font_size=" +
      encodeURIComponent(schoolNameFontSize) +
      "&school_code=" +
      SCHOOL_CODE +
      "&_t=" +
      Date.now();

    setFILE_URL(url);
  };

  const changeColor = (index) => {
    setSELECTED_COLOR_POSITION(index);
    setShowStudentIdCard(true);

    const selectedColor = mColorOption[index];
    const colorOptionId = selectedColor ? selectedColor.color_option_id : "";
    setCOLOR_OPTION_ID(colorOptionId);

    const hasSelection =
      SELECTION_TYPE === "staff"
        ? mSelectedStaff.length > 0
        : mSelectedStudent.length > 0;

    if (hasSelection) {
      setFileUrL(
        undefined,
        FILE_NAME,
        FILE_DIRECTORY,
        SELECTED_SAMPLE_ID,
        colorOptionId
      );
    }
  };

  const changeSample = (position) => {
    setSELECTED_SAMPLE_POSITION(position);
    setShowStudentIdCard(true);
    setSample(position);
  };

  const HandleSelectedStudent = (selectedStudents) => {
    const students = selectedStudents || [];
    setIsOpenSelectStudent(false);
    setShowStudentIdCard(true);
    setMSelectedStudent(students);
    setSELECTION_TYPE("student");
    setMSelectedStaff([]);
    const nextType = isStaffCertificateType(certificateType)
      ? "STUDENT_APPRECIATION"
      : certificateType;
    if (isStaffCertificateType(certificateType)) {
      setCertificateType(nextType);
    }
    //Created By Cursor — student samples from route document_type
    getPrintableSamples(DOCUMENT_TYPE, "student", nextType, students);
  };

  //Created By Cursor
  const changeCertificateType = (type) => {
    setCertificateType(type);
    const staffType = isStaffCertificateType(type);

    if (staffType) {
      setSELECTION_TYPE(mSelectedStaff.length > 0 ? "staff" : "");
      setMSelectedStudent([]);
      //Created By Cursor — staff samples from appreciation_certificate_staff
      getPrintableSamples(
        STAFF_DOCUMENT_TYPE,
        "staff",
        type,
        mSelectedStaff.length > 0 ? mSelectedStaff : []
      );
      if (mSelectedStaff.length === 0) {
        setFILE_URL("");
        setIsOpenSelectStaff(true);
      }
      return;
    }

    setSELECTION_TYPE(mSelectedStudent.length > 0 ? "student" : "");
    setMSelectedStaff([]);
    //Created By Cursor — student samples from route document_type
    getPrintableSamples(
      DOCUMENT_TYPE,
      "student",
      type,
      mSelectedStudent.length > 0 ? mSelectedStudent : []
    );
  };

  //Created By Cursor
  const HandleSelectedStaff = (selectedStaff) => {
    const staff = selectedStaff || [];
    setIsOpenSelectStaff(false);
    setShowStudentIdCard(true);
    setMSelectedStaff(staff);
    setSELECTION_TYPE("staff");
    setMSelectedStudent([]);

    const nextType = isStaffCertificateType(certificateType)
      ? certificateType
      : "STAFF_APPRECIATION";
    if (!isStaffCertificateType(certificateType)) {
      setCertificateType(nextType);
    }

    //Created By Cursor — staff samples from appreciation_certificate_staff
    getPrintableSamples(STAFF_DOCUMENT_TYPE, "staff", nextType, staff);
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (Loading) {
    return <MyLoader />;
  }

  return (
    <div className="content event-certificate">
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <a href="#" style={{ color: COLORS.white }}>
                Appreciation Certificate
              </a>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="page-card">
        <div className="header-section">
          <div className="header-content">
            <h5>Appreciation Certificate</h5>
            <small>
              Create appreciation certificates for students and staff
            </small>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
            <Link
              to="/AdminMain/CertificateSettings"
              className="selection-button"
              style={{
                fontWeight: 700,
                background:
                  "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
                textDecoration: "none",
              }}
            >
              <i className="fa fa-font" />
              Certificate Settings
            </Link>
            <div className="header-icon">
              <i className="fa fa-certificate"></i>
            </div>
            <button
              className="selection-button"
              onClick={() => setIsOpenSelectStudent(true)}
              style={{
                fontWeight: 700,
                background:
                  "linear-gradient(135deg, #f59e0b 0%, #f97316 100%)",
              }}
            >
              <i className="fa fa-user-plus" />
              Select Students
            </button>
            <button
              className="selection-button"
              onClick={() => setIsOpenSelectStaff(true)}
              style={{
                fontWeight: 700,
                background:
                  "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
              }}
            >
              <i className="fa fa-users" />
              Select Staff
            </button>
          </div>
        </div>

        <div
          className="selection-section"
          style={{ margin: "16px 20px 0 20px" }}
        >
          <h5 className="section-title">
            <i className="fa fa-award" style={{ marginRight: "6px" }} />
            Certificate Type
          </h5>
          <div className="certificate-type-grid">
            {certificateTypes.map((type) => {
              const isStaffType = [
                "STAFF_APPRECIATION",
                "BEST_TEACHER",
              ].includes(type.value);
              const isStudentType = [
                "STUDENT_APPRECIATION",
                "STUDENT_OF_YEAR",
                "SMART_STUDY",
              ].includes(type.value);

              const isStaffSelected = SELECTION_TYPE === "staff";
              const isStudentSelected = SELECTION_TYPE === "student";

              const disabled =
                (isStaffType && isStudentSelected) ||
                (isStudentType && isStaffSelected);

              const isActive = certificateType === type.value && !disabled;

              return (
                <div
                  key={type.value}
                  className={`certificate-type-item ${
                    isActive ? "active" : disabled ? "disabled" : ""
                  }`}
                  onClick={() => !disabled && changeCertificateType(type.value)}
                  style={{
                    borderColor: isActive ? type.color : undefined,
                    background: isActive ? `${type.color}08` : undefined,
                    opacity: disabled ? 0.4 : 1,
                    cursor: disabled ? "not-allowed" : "pointer",
                  }}
                >
                  <div
                    className="certificate-type-icon"
                    style={{ background: type.color }}
                  >
                    <i className={`fa ${type.icon}`}></i>
                  </div>
                  <span
                    className="certificate-type-label"
                    style={{
                      color: isActive ? type.color : undefined,
                    }}
                  >
                    {type.label}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        <div
          className="selection-section"
          style={{ margin: "16px 20px 0 20px" }}
        >
          <h5 className="section-title">
            <i className="fa fa-certificate" style={{ marginRight: "6px" }} />
            Certificate Templates
          </h5>
          <div className="templates-grid">
            {mPrintableSamples.map((item, index) => (
              <div
                key={index}
                className={`template-item ${
                  SELECTED_SAMPLE_POSITION === index ? "active" : ""
                }`}
                onClick={() => changeSample(index)}
              >
                <i className="fa fa-file-text-o template-icon"></i>
                <div className="template-name">{getTemplateDisplayName(item, index)}</div>
              </div>
            ))}
          </div>
        </div>

        {mColorOption.length > 0 && (
          <div
            className="selection-section"
            style={{ margin: "16px 20px 0 20px" }}
          >
            <h5 className="section-title">
              <i className="fa fa-paint-brush" style={{ marginRight: "6px" }} />
              Color Options
            </h5>
            <div
              className="color-options"
              style={{ maxWidth: "420px", margin: "0 auto" }}
            >
              {mColorOption.map((item, index) => {
                const [color1, color2] = item.sample_color_code.split("_");
                const isSelected = SELECTED_COLOR_POSITION === index;
                return (
                  <div
                    key={index}
                    className={`color-option ${isSelected ? "active" : ""}`}
                    onClick={() => changeColor(index)}
                  >
                    <div className="color-display">
                      <div style={{ backgroundColor: color1 }}></div>
                      <div style={{ backgroundColor: color2 }}></div>
                    </div>
                    <div className="color-name">{item.sample_color_name}</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        <div
          className="preview-section"
          style={{ margin: "16px 20px 20px 20px" }}
        >
          <h5 className="section-title">
            <i className="fa fa-eye" style={{ marginRight: "6px" }} />
            Preview
          </h5>
          <div className="preview-frame">
            {SELECTION_TYPE === "student" && mSelectedStudent.length === 0 ? (
              <div className="no-students-message">
                <i className="fa fa-user-plus" />
                <h4>No Students Selected</h4>
                <p>Please select students to preview the certificate</p>
              </div>
            ) : SELECTION_TYPE === "staff" && mSelectedStaff.length === 0 ? (
              <div className="no-students-message">
                <i className="fa fa-users" />
                <h4>No Staff Selected</h4>
                <p>Please select staff to preview the certificate</p>
              </div>
            ) : !SELECTION_TYPE ? (
              <div className="no-students-message">
                <i className="fa fa-user-plus" />
                <h4>No Selection Yet</h4>
                <p>Select students or staff to preview the certificate</p>
              </div>
            ) : (
              <>
                {showStudentIdCard && <MyLoader />}
                <Iframe
                  url={FILE_URL}
                  width="100%"
                  height={height}
                  overflow="visible"
                  id="iFrameStudentId"
                  className="bg_card_primary_outline"
                  display="initial"
                  position="relative"
                  onLoad={() => setShowStudentIdCard(false)}
                />
              </>
            )}
          </div>
        </div>
      </div>

      {isOpenSelectStudent && (
        <MdlSelectMultipleStudent
          actionClose={() => setIsOpenSelectStudent(false)}
          actionHandleSelected={HandleSelectedStudent}
        />
      )}
      {isOpenSelectStaff && (
        <MdlSelectMultipleStaff
          actionClose={() => setIsOpenSelectStaff(false)}
          actionHandleSelected={HandleSelectedStaff}
        />
      )}
    </div>
  );
};

export default AppreciationCertificate;
